import {
  VehiculeInfo
} from './index';

export class Groupe {
  public idGroupe: number;
  public nom: string;
  public imageUrl: string;
  public vehicules: VehiculeInfo[] = [];
  constructor(groupeId: number, nom: string, imageUrl: string, vehicules: VehiculeInfo[]) {
    this.idGroupe = groupeId;
    this.nom = nom;
    this.imageUrl = imageUrl;
    this.vehicules = vehicules;
  }
}

export class VehiculeGetDTO {
  public idVehicule: number;
  public matricule: String
  constructor(idVehicule: number, matricule: String) {
    this.idVehicule = idVehicule;
    this.matricule = matricule;
  }

}

export class GroupAddDTO {
  public idGroupe: number;
  public name: string;
  public idVehicules: any;
  public imageUrl: string;
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/objects/group.ts